export const translations = {
  en: {
    // Navbar
    nav: {
      whyAvopla: "Why Avopla?",
      pricing: "Pricing",
      login: "Login"
    },
    
    // Footer
    footer: {
      signIn: "Sign In",
      privacyPolicy: "Privacy policy",
      termsOfUse: "Terms of use",
      ourPlans: "Our plans",
      contactUs: "Contact us",
      copyright: "Copyright 2025 Avopla, Inc"
    },
    
    // WhyAvopla Page
    whyAvopla: {
      // Hero Section
      hero: {
        title: "Connect with our dinner network and start with avopla manager for reservations management",
        registerButton: "REGISTER RESTAURANT",
        exploreButton: "Explore plans"
      },
      
      // Win-Win Section
      winWin: {
        title: "WIN-WIN PARTNERSHIP",
        subtitle: "Avopla, where every culinary getaway starts"
      },
      
      // Powerful Section
      powerful: {
        title: "HOW AVOPLA CAN BE POWERFUL",
        reachAudience: {
          title: "Reach more audience",
          text: "Manage your table occupancy and increase the rate by reaching new diners .Propose discounts for your diners and have total control how and when that offers are applied."
        },
        takeControl: {
          title: "Take control on reservations",
          text: "With simplified reservation management, maintain control for optimized and seamless service. Our intuitive management tool will guide your daily operations. It’s time to take control by managing availabilities, handling online reservations, sending reminders, proposing offers and responding on reviews."
        },
        beClose: {
          title: "Be close to your guests",
          text: "Diners who have visited your restaurant may leave reviews about their experiences. Responding to their comments is the perfect way to build trust with your customers. Communicating is about enhancing reputation."
        },
        limitNoShow: {
          title: "Limit the no show",
          text: "Our easy-use application make all reservations cancellation easy and instant for the diners. We also give you the hand to remind your diners on their upcoming reservations.We work together with diners to reduce the no-show rates"
        }
      },
      
      // Reach More Foodies Section
      reachFoodies: {
        title: "REACH OUT MORE FOODIES",
        largerAudience: {
          title: "Reach larger audience",
          text: "Be part of large table reservations spotlight and reach our large dining network. Customize your restaurant page with your photos, menus, reviews, and reservation calendar with bookable dates and times."
        },
        promotional: {
          title: "Use promotional offers",
          text: "Propose discounts for your diners and have total control on how and when that offers are applied. Making offers on the off-pick periods will help you attract new diners and increase your occupancy rates"
        },
        whatDiners: {
          title: "What diners need to know",
          text: "Because every detail counts, the restaurant details page will display all guests need to know before making their choice mainly when information is clear and easy to find."
        },
        moreVisible: {
          title: "Be more visible",
          text: "By joining Avopla, you increase your visibility targeting a large dining network. Your restaurant will be available for reservations 24/7."
        }
      },
      
      // Customer Experience Section
      customerExp: {
        title: "CUSTOMER EXPERIENCE",
        reviewsVisibility: {
          title: "Reviews full visibility",
          text: "Get a permanent view on your diners reviews. Be sure, only guests who have honored their reservation can review and rate their experience. Take a permanent look to your overall rating score, list all reservations reviews, check comments and reviews photos."
        },
        respondFeedback: {
          title: "Respond to feedbacks",
          text: "Diners who have visited your restaurant may leave reviews about their experiences. Responding to their comments is the perfect way to build trust with your customers. Communicating is about enhancing reputation."
        },
        increaseInfluence: {
          title: "Increase influence",
          text: "A good comment system with replying options increase diners trust. Every happy diners will make your restaurant shining."
        },
        automaticSurvey: {
          title: "Automatic survey sending",
          text: "We take care of sending an automatic survey after each honored reservation. We give the opportunity for every diner to give his feedback using an easy and clear form, publish it after a careful check."
        }
      },
      
      // Control Reservations Section
      controlReservations: {
        title: "HAVE CONTROL ON RESERVATIONS",
        listAll: {
          title: "List all reservations",
          text: "We make things easier for you as restaurant manager by listing your upcoming and past reservations. For each, every single detail as diners special request will help you making good decisions."
        },
        limitNoShow: {
          title: "Limit the no-show",
          text: "Reminders can be sent to diners for upcoming reservations, that helps guests to check the reservation details and cancel in case they cannot honor their presence. Users' statistics at your restaurant will help you taking the right decision by identifying potential no-showers"
        },
        manageDining: {
          title: "Manage your dining room",
          text: "Our seating plan is the complete way to organise all reservations. By assigning tables to each reservation, we make sure to help you running services smartly and smoothly. You can view in real-time your table occupations and improve the way it is occupied."
        },
        takeControlEach: {
          title: "Take control on each reservation",
          text: "When necessary, restaurant can move reservation with diners agreement. Restaurant can choose to maintain the approved offer or not. For each timeslot, restaurant can check all availabilities and make sure he has enough seats for any changes. Never been easier to take action as rejecting reservations in case of any service interruption or simply announce the non presence of a diners."
        }
      },
      
      // Footer CTA
      footerCta: {
        title: "READY TO BE PART OF OUR DINING TABLES",
        subtitle: "The easy way to promote your restaurant and increase your occupancy rate",
        button: "REGISTER RESTAURANT"
      }
    },
    
    // Pricing Page
    pricing: {
      hero: {
        title: "The easy way to manage your reservations",
        subtitle: "Because every reservation count!",
        registerButton: "REGISTER RESTAURANT"
      },
      shine: {
        title: "Shine in the AVOPLA world, enhance your visibility, get more guests and increase your incomes",
        text: "Get access to our foodies community and be bookable 24/7"
      },
      plans: {
        title: "Ready to promote your restaurant",
        subtitle: "Choose the plan that matches your needs",
        cancelAnytime: "Cancel anytime!"
      },
      basic: {
        title: "essential",
        getStarted: "Get started",
        features: {
          f1: "Get charged based on percentage of your menu's average price for each diners coming from Avopla",
          f2: "Receive instant and unlimited reservations",
          f3: "List and promote your restaurant profile and activate reservation tool",
          f4: "Automate your reservations process",
          f5: "Get access to your Guests book",
          f6: "Enjoy our EASY-TO-USE application to manage reservations",
          f7: "Use Dashboard for reporting and statistics to analyse your reservations data",
          f8: "Propose offers for time slots that align with your restaurant's strategy",
          f9: "Automated review form to only diners who honored their reservations",
          f10: "Get reviews visibility and reply to your guests reviews"
        }
      },
      premium: {
        title: "Premium",
        comingSoon: "Coming soon!",
        contactSales: "Contact sales",
        allBasic: "All Basic features included",
        features: {
          f1: "Table management and assignation",
          f2: "Special event feature",
          f3: "Waitlist feature",
          f4: "Bad reviews alerting feature",
          f5: "POS integration",
          f6: "Credit cards holds",
          f7: "Guestbook export"
        }
      },
      faq: {
        title: "Frequently asked questions",
        subtitle: "Find your answers quickly from that selected FAQ",
        seeAll: "SEE all FAQs",
        q1: {
          question: "Does Avopla charges covers for No-show reservations?",
          answer: "Avopla only charges cover fees for honored reservations that comes from Avopla's platforms (website and mobile application). The Cancelled, rejected and No-show reservations will not be charged for your restaurant."
        },
        q2: {
          question: "How do special offers works?",
          answer: "The special offers are discounts you can enable exclusively for Avopla diners. Restaurant have full hand to make offers on the desired dates, times and party size. There is no obligation to propose the special offers to get listed on our search engine, however, having special discounts can improve your listing and increase your tables occupation rates."
        },
        q3: {
          question: "Is the reservation process automated?",
          answer: "The restaurant detailed page on Avopla platforms, has a fully automated reservation process that helps guests making their reservations in some clicks. When reservation is made, we do sent notifications to restaurant at the same time as the guest. Restaurant can check all upcoming and past reservations on the easy-to-use management platform and has the hand to manage it and see all reservation and guest details."
        },
        q4: {
          question: "Can we customize our online reservation calendar?",
          answer: "Avopla makes all processes easy and efficient. You will be responsible for your online availabilities add and edit as per as your restaurant goals. The reservations can be enabled using your own starting and ending date and time, the party size and available seats for each time shift. Each restaurant creates a unique reservation calendar to make a unique strategy, we are helping you improve your visibility and increase your restaurants profits by increasing your table occupation rate."
        },
        q5: {
          question: "Is Avopla charging a monthly fees for basic plan?",
          answer: "The basic plan offer free monthly fees. With the basic plan, we only charge for you a percentage based on your average price menu (calculated by our team based on your menu) on each cover coming from Avopla platforms (website and mobile application). Only honored reservations are charged."
        }
      },
      contact: {
        title: "Tell us about your restaurant",
        subtitle: "We will be happy to discuss with you about your business needs.",
        contactDetails: "contact details",
        restaurantDetails: "Restaurant details",
        submit: "Submit",
        firstName: "First name",
        lastName: "Last name",
        email: "Your email address",
        phone: "Your phone number",
        bestWay: "best way to contact you",
        selectPlaceholder: "Select",
        byEmail: "By Email",
        byPhone: "By Phone",
        ownOrManage: "Do you own or manage the restaurant?",
        yes: "Yes",
        no: "No",
        whichPlan: "Which plan do you think fitting closer to your business needs?",
        basicPlan: "Basic plan",
        premiumPlan: "Premium plan",
        restaurantName: "your restaurant name",
        restaurantAddress: "your restaurant address",
        purpose: "The purpose of contacting us",
        learnAbout: "I want to learn about Avopla",
        scheduleDemo: "I want to schedule a demo",
        howManyTables: "How many tables you expect to enable online",
        tables5_10: "5-10",
        tables11_20: "11-20",
        tables21plus: "21 +"
      },
      messages: {
        success: "Email sent successfully",
        error: "Some information missing"
      }
    },
    
    // Registration Page
    registration: {
      whyPartner: {
        title: "why should you partner with AVOpla?",
        item1: {
          label: "attract more foodies",
          text: "Increase your visibility and draw more food lovers to your restaurant. With our platform, your restaurant reaches the right audience at the right time. Showcase your dishes, share special offers to convince even more diners"
        },
        item2: {
          label: "get full control",
          text: "Our platform gives you complete control over reservations, table management, customer insights, and promotional offers—all from one intuitive dashboard"
        },
        item3: {
          label: "Build your reputation",
          text: "Strengthen your presence with a dedicated restaurant page featuring all the relevant details. Get verified reviews from real diners and respond directly to your guests."
        }
      },
      contact: {
        title: "Tell us about your restaurant",
        subtitle: "We will be happy to discuss with you about your business needs.",
        contactDetails: "contact details",
        restaurantDetails: "Restaurant details",
        submit: "Submit",
        firstName: "First name",
        lastName: "Last name",
        email: "Your email address",
        phone: "Your phone number",
        bestWay: "best way to contact you",
        selectPlaceholder: "Select",
        byEmail: "By Email",
        byPhone: "By Phone",
        ownOrManage: "Do you own or manage the restaurant?",
        yes: "Yes",
        no: "No",
        whichPlan: "Which plan do you think fitting closer to your business needs?",
        basicPlan: "Basic plan",
        premiumPlan: "Premium plan",
        restaurantName: "your restaurant name",
        restaurantAddress: "your restaurant address",
        purpose: "The purpose of contacting us",
        learnAbout: "I want to learn about Avopla",
        scheduleDemo: "I want to schedule a demo",
        howManyTables: "How many tables you expect to enable online",
        tables5_10: "5-10",
        tables11_20: "11-20",
        tables21plus: "21 +"
      },
      messages: {
        success: "Email sent successfully",
        error: "Some information missing"
      }
    }
  },
  
  fr: {
    // Navbar
    nav: {
      whyAvopla: "Pourquoi Avopla?",
      pricing: "Tarification",
      login: "Connexion"
    },
    
    // Footer
    footer: {
      signIn: "Se connecter",
      privacyPolicy: "Politique de confidentialité",
      termsOfUse: "Conditions d'utilisation",
      ourPlans: "Nos forfaits",
      contactUs: "Nous contacter",
      copyright: "Copyright 2025 Avopla, Inc"
    },
    
    // WhyAvopla Page
    whyAvopla: {
      // Hero Section
      hero: {
        title: "Connectez-vous à notre réseau de dîners et commencez avec Avopla Manager pour la gestion des réservations",
        registerButton: "INSCRIRE LE RESTAURANT",
        exploreButton: "Découvrir les forfaits"
      },
      
      // Win-Win Section
      winWin: {
        title: "PARTENARIAT GAGNANT-GAGNANT",
        subtitle: "Avopla, où commence chaque escapade culinaire"
      },
      
      // Powerful Section
      powerful: {
        title: "COMMENT AVOPLA PEUT ÊTRE PUISSANT",
        reachAudience: {
          title: " Accédez à plus de clients",
          text: "Optimisez le taux d'occupation de vos tables et augmentez votre chiffre d'affaires en attirant de nouveaux clients. Proposez des offres et appliquez les sur les créneaux de votre choix."
        },
        takeControl: {
          title: "Prenez le contrôle des réservations",
          text: "Grâce à une gestion simplifiée des réservations, gardez le contrôle et bénéficiez d'un service optimal et sans faille. Notre outil de gestion intuitif vous accompagne au quotidien. Prenez les rênes : gérez les disponibilités, les réservations en ligne, envoyez des rappels, proposez des offres et répondez aux avis."
        },
        beClose: {
          title: "Soyez proche de vos invités",
          text: "Les convives qui ont visité votre restaurant peuvent laisser des avis sur leurs expériences. Répondre à leurs commentaires est le moyen idéal pour établir la confiance avec vos clients. Communiquer, c'est améliorer la réputation."
        },
        limitNoShow: {
          title: "Limitez les no show",
          text: "Notre application facile à utiliser rend toutes les annulations de réservations faciles et instantanées pour les convives. Nous vous donnons également la possibilité de rappeler à vos convives leurs réservations à venir. Nous travaillons ensemble avec les convives pour réduire les taux d'absence"
        }
      },
      
      // Reach More Foodies Section
      reachFoodies: {
        title: "Attirez plus de gourmets",
        largerAudience: {
          title: "Accédez une plus grande communauté",
          text: "Bénéficiez d'une visibilité accrue grâce à notre vaste réseau de gourmets. Personnalisez la page de votre restaurant avec vos photos, menus, avis et calendrier de réservation indiquant les dates et heures disponibles."
        },
        promotional: {
          title: "Utilisez les offres promotionnelles",
          text: "Proposez des réductions à vos convives et gardez le contrôle total sur comment et quand ces offres sont appliquées. Faire des offres pendant les périodes creuses vous aidera à attirer de nouveaux convives et à augmenter vos taux d'occupation"
        },
        whatDiners: {
          title: "Ce que les convives doivent savoir",
          text: "Parce que chaque détail compte, la page du restaurant affichera toutes les informations dont les clients ont besoin avant de faire leur choix, notamment lorsque ces informations sont claires et faciles à trouver."
        },
        moreVisible: {
          title: "Soyez plus visible",
          text: "En rejoignant Avopla, vous renforcez votre visibilité auprès d'un vaste réseau de gourmets. Votre restaurant sera disponible à la réservation 24h/24 et 7j/7."
        }
      },
      
      // Customer Experience Section
      customerExp: {
        title: "EXPÉRIENCE CLIENT",
        reviewsVisibility: {
          title: "Visibilité totale des avis",
          text: "Obtenez une vue permanente sur les avis de vos convives. Soyez assuré, seuls les invités qui ont honoré leur réservation peuvent évaluer et noter leur expérience. Consultez en permanence votre note globale, listez tous les avis de réservations, vérifiez les commentaires et les photos d'avis."
        },
        respondFeedback: {
          title: "Répondez aux commentaires",
          text: "Les convives qui ont visité votre restaurant peuvent laisser des avis sur leurs expériences. Répondre à leurs commentaires est le moyen idéal pour établir la confiance avec vos clients. Communiquer, c'est améliorer la réputation."
        },
        increaseInfluence: {
          title: "Augmentez l'influence",
          text: "Un bon système de commentaires avec options de réponse augmente la confiance des convives. Chaque convive satisfait fera briller votre restaurant."
        },
        automaticSurvey: {
          title: "Envoi automatique de sondages",
          text: "Nous nous occupons d'envoyer un sondage automatique après chaque réservation honorée. Nous donnons l'opportunité à chaque convive de donner son feedback en utilisant un formulaire simple et clair, publié après une vérification minutieuse."
        }
      },
      
      // Control Reservations Section
      controlReservations: {
        title: "AYEZ LE CONTRÔLE SUR LES RÉSERVATIONS",
        listAll: {
          title: "Listez toutes les réservations",
          text: "Nous facilitons les choses pour vous en tant que gestionnaire de restaurant en listant vos réservations à venir et passées. Pour chacune, chaque détail comme les demandes spéciales des convives vous aidera à prendre de bonnes décisions."
        },
        limitNoShow: {
          title: "Limitez les no show",
          text: "Des rappels peuvent être envoyés aux convives pour les réservations à venir, ce qui aide les invités à vérifier les détails de la réservation et à annuler au cas où ils ne peuvent pas honorer leur présence. Les statistiques des utilisateurs dans votre restaurant vous aideront à prendre la bonne décision en identifiant les absences potentielles"
        },
        manageDining: {
          title: "Gérez votre salle à manger",
          text: "Notre plan de salle est le moyen complet d'organiser toutes les réservations. En assignant des tables à chaque réservation, nous nous assurons de vous aider à gérer les services intelligemment et en douceur. Vous pouvez visualiser en temps réel l'occupation de vos tables et améliorer la façon dont elles sont occupées."
        },
        takeControlEach: {
          title: "Prenez le contrôle de chaque réservation",
          text: "Si nécessaire, le restaurant peut déplacer la réservation avec l'accord des convives. Le restaurant peut choisir de maintenir l'offre approuvée ou non. Pour chaque créneau horaire, le restaurant peut vérifier toutes les disponibilités et s'assurer d'avoir suffisamment de places pour tout changement. Il n'a jamais été aussi facile de prendre des mesures comme refuser des réservations en cas d'interruption de service ou simplement annoncer l'absence d'un convive."
        }
      },
      
      // Footer CTA
      footerCta: {
        title: "PRÊT À FAIRE PARTIE DE NOS TABLES DE RESTAURATION",
        subtitle: "Le moyen facile de promouvoir votre restaurant et d'augmenter votre taux d'occupation",
        button: "INSCRIRE LE RESTAURANT"
      }
    },
    
    // Pricing Page
    pricing: {
      hero: {
        title: "La façon simple de gérer vos réservations",
        subtitle: "Parce que chaque réservation compte!",
        registerButton: "INSCRIRE LE RESTAURANT"
      },
      shine: {
        title: "Brillez dans l'univers AVOPLA, améliorez votre visibilité, attirez plus de clients et augmentez vos revenus.",
        text: "Accédez à notre communauté de gourmets et soyez disponible 24h/24 et 7j/7."
      },
      plans: {
        title: "Prêt à promouvoir votre restaurant",
        subtitle: "Choisissez le forfait qui correspond à vos besoins",
        cancelAnytime: "Annulez à tout moment!"
      },
      basic: {
        title: "Essentiel",
        getStarted: "Commencer",
        features: {
          f1: "Soyez facturé en fonction d'un pourcentage du prix moyen de votre menu pour chaque convive venant d'Avopla",
          f2: "Recevez des réservations instantanées et illimitées",
          f3: "Listez et promouvez le profil de votre restaurant et activez l'outil de réservation",
          f4: "Automatisez votre processus de réservations",
          f5: "Accédez à votre livre d'invités",
          f6: "Profitez de notre plateforme intuitive pour gérer les réservations",
          f7: "Utilisez le tableau de bord pour les rapports et statistiques afin d'analyser vos données de réservations",
          f8: "Proposez des offres sur les créneaux horaires qui correspondent à la stratégie de votre restaurant",
          f9: "Formulaire d'avis automatisé uniquement pour les convives qui ont honoré leurs réservations",
          f10: "Obtenez la visibilité des avis et répondez aux avis de vos invités"
        }
      },
      premium: {
        title: "Premium",
        comingSoon: "Bientôt disponible!",
        contactSales: "Contacter les ventes",
        allBasic: "Toutes les fonctionnalités Basiques incluses",
        features: {
          f1: "Gestion et assignation des tables",
          f2: "Évènements spéciaux",
          f3: "Liste d'attente",
          f4: "Alertes sur les avis négatifs",
          f5: "Intégration POS",
          f6: "Export du carnet clients",
          f7: "Empreinte bancaire et prépaiement"
        }
      },
      faq: {
        title: "Questions fréquemment posées",
        subtitle: "Trouvez rapidement votre réponse dans cette FAQ sélectionnée",
        seeAll: "VOIR toutes les FAQ",
        q1: {
          question: "Est-ce qu'Avopla facture les couverts pour les réservations non-honorées?",
          answer: "Avopla facture uniquement les frais de couvert pour les réservations honorées provenant des plateformes d'Avopla (site web et application mobile). Les réservations annulées, rejetées et non-honorées ne seront pas facturées à votre restaurant."
        },
        q2: {
          question: "Comment fonctionnent les offres spéciales?",
          answer: "Les offres spéciales sont des réductions que vous pouvez activer exclusivement pour les convives d'Avopla. Le restaurant a la main libre pour faire des offres aux dates, heures et tailles de groupe souhaités. Il n'y a aucune obligation de proposer des offres spéciales pour être listé sur notre moteur de recherche, cependant, avoir des réductions spéciales peut améliorer votre référencement et augmenter vos taux d'occupation des tables."
        },
        q3: {
          question: "Le processus de réservation est-il automatisé?",
          answer: "La page détaillée du restaurant sur les plateformes Avopla dispose d'un processus de réservation entièrement automatisé qui aide les invités à effectuer leurs réservations en quelques clics. Lorsqu'une réservation est effectuée, nous envoyons des notifications au restaurant en même temps qu'à l'invité. Le restaurant peut vérifier toutes les réservations à venir et passées sur la plateforme de gestion facile à utiliser et a la main pour la gérer et voir tous les détails de réservation et d'invité."
        },
        q4: {
          question: "Pouvons-nous personnaliser notre calendrier de réservation en ligne?",
          answer: "Avopla rend tous les processus faciles et efficaces. Vous serez responsable de l'ajout et de la modification de vos disponibilités en ligne selon les objectifs de votre restaurant. Les réservations peuvent être activées en utilisant votre propre date et heure de début et de fin, la taille du groupe et les places disponibles pour chaque créneau horaire. Chaque restaurant crée un calendrier de réservation unique pour élaborer une stratégie unique, nous vous aidons à améliorer votre visibilité et à augmenter les profits de vos restaurants en augmentant votre taux d'occupation des tables."
        },
        q5: {
          question: "Avopla facture-t-il des frais mensuels pour le plan basique?",
          answer: "Le plan basique offre des frais mensuels gratuits. Avec le plan basique, nous ne facturons qu'un pourcentage basé sur le prix moyen de votre menu (calculé par notre équipe en fonction de votre menu) sur chaque couvert provenant des plateformes Avopla (site web et application mobile). Seules les réservations honorées sont facturées."
        }
      },
      contact: {
        title: "Parlez-nous de votre restaurant",
        subtitle: "Nous serons heureux de discuter avec vous de vos besoins commerciaux.",
        contactDetails: "coordonnées",
        restaurantDetails: "Détails du restaurant",
        submit: "Soumettre",
        firstName: "Prénom",
        lastName: "Nom",
        email: "Votre adresse e-mail",
        phone: "Votre numéro de téléphone",
        bestWay: "meilleur moyen de vous contacter",
        selectPlaceholder: "Sélectionner",
        byEmail: "Par e-mail",
        byPhone: "Par téléphone",
        ownOrManage: "Êtes-vous propriétaire ou gérant du restaurant?",
        yes: "Oui",
        no: "Non",
        whichPlan: "Quel forfait pensez-vous être le plus adapté à vos besoins commerciaux?",
        basicPlan: "Plan basique",
        premiumPlan: "Plan premium",
        restaurantName: "le nom de votre restaurant",
        restaurantAddress: "l'adresse de votre restaurant",
        purpose: "Le but de nous contacter",
        learnAbout: "Je veux en savoir plus sur Avopla",
        scheduleDemo: "Je veux planifier une démo",
        howManyTables: "Combien de tables prévoyez-vous d'activer en ligne",
        tables5_10: "5-10",
        tables11_20: "11-20",
        tables21plus: "21 +"
      },
      messages: {
        success: "Email envoyé avec succès",
        error: "Certaines informations sont manquantes"
      }
    },
    
    // Registration Page
    registration: {
      whyPartner: {
        title: "Pourquoi un partenariat avec nous?",
        item1: {
          label: "Attirez plus de gourmands",
          text: "Boostez votre visibilité et attirez plus de gourmets dans votre restaurant. Avec notre plateforme, touchez le bon public au bon moment, mettez en avant vos plats et proposez des offres spéciales pour séduire encore plus de clients."
        },
        item2: {
          label: "Ayez le contôle",
          text: "Notre plateforme vous donne un contrôle total sur les réservations, la gestion des tables, les informations client et les offres promotionnelles—le tout depuis un tableau de bord intuitif"
        },
        item3: {
          label: "Renforcez votre réputation",
          text: "Renforcez votre présence en disposant d'une page dédiée à votre restaurant avec tous les détails pertinents. Obtenez des avis vérifiés de vrais clients et répondez directement à vos convives."
        }
      },
      contact: {
        title: "Parlez-nous de votre restaurant",
        subtitle: "Nous serons heureux de discuter avec vous de vos besoins commerciaux.",
        contactDetails: "coordonnées",
        restaurantDetails: "Détails du restaurant",
        submit: "Soumettre",
        firstName: "Prénom",
        lastName: "Nom",
        email: "Votre adresse e-mail",
        phone: "Votre numéro de téléphone",
        bestWay: "meilleur moyen de vous contacter",
        selectPlaceholder: "Sélectionner",
        byEmail: "Par e-mail",
        byPhone: "Par téléphone",
        ownOrManage: "Êtes-vous propriétaire ou gérant du restaurant?",
        yes: "Oui",
        no: "Non",
        whichPlan: "Quel forfait pensez-vous être le plus adapté à vos besoins commerciaux?",
        basicPlan: "Plan basique",
        premiumPlan: "Plan premium",
        restaurantName: "le nom de votre restaurant",
        restaurantAddress: "l'adresse de votre restaurant",
        purpose: "Le but de nous contacter",
        learnAbout: "Je veux en savoir plus sur Avopla",
        scheduleDemo: "Je veux planifier une démo",
        howManyTables: "Combien de tables prévoyez-vous d'activer en ligne",
        tables5_10: "5-10",
        tables11_20: "11-20",
        tables21plus: "21 +"
      },
      messages: {
        success: "Email envoyé avec succès",
        error: "Certaines informations sont manquantes"
      }
    }
  }
};
